import * as React from "react";
const SvgFiRrFeatures = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-features_svg__a)">
      <path
        fill="#062147"
        d="M5 6a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1m6 3H6a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2m0 4H6a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2m12.939-8.343A1 1 0 0 0 23 4h-3.001l-1.062-2.98a1.001 1.001 0 0 0-1.874 0L16.001 4H13a1 1 0 0 0-.646 1.762l2.377 1.935-.941 3.016a1.003 1.003 0 0 0 .954 1.301 1 1 0 0 0 .556-.169l2.708-1.812 2.754 1.793a1.002 1.002 0 0 0 1.495-1.152l-.979-2.98 2.366-1.927a1 1 0 0 0 .295-1.108zM22 20v.5c0 1.93-1.57 3.5-3.5 3.5H3.499A3.504 3.504 0 0 1 0 20.5V5c0-2.757 2.243-5 5-5h8a1 1 0 1 1 0 2H5C3.346 2 2 3.346 2 5v15.5c0 .827.673 1.5 1.5 1.5S5 21.327 5 20.5V20c0-1.654 1.346-3 3-3h9v-3a1 1 0 1 1 2 0v3c1.654 0 3 1.346 3 3m-2 0c0-.552-.449-1-1-1H8c-.551 0-1 .448-1 1v.5a3.5 3.5 0 0 1-.338 1.5H18.5c.827 0 1.5-.673 1.5-1.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-features_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFeatures;
